import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import Grid from '@material-ui/core/Grid';
// import Paper from '@material-ui/core/Paper';
// import { black } from 'material-ui/styles/colors';
// import TextField from '@material-ui/core/TextField';
import { Button, Select, MenuItem, makeStyles } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import './style.css';
import { COLORS } from '../../constants';

const styles = {
  builderCard: {
    margin: '2rem auto',
  },
  resultsRow: {
    margin: '10px',
  },
  emailField: {
    width: '90%',
  },
  viewBtn: {
    backgroundColor: COLORS.GREEN,
    color: COLORS.WHITE,
  },
};

const BuilderCard = props => {
  // const { builder, setBuilder } = props;
  const { builder } = props;
  // const { status, name, email } = builder;

  return (
    <div style={styles.builderCard}>
      {builder && (
        <div>
          <div>{JSON.stringify(builder)}</div>
        </div>
      )}
    </div>
  );
};

const BuilderResults = props => {
  const { builders, setBuilder } = props;
  const [activityStatus, setActivityStatus] = useState('All');
  // const buildersUpdated = [];
  const columns = [
    { field: 'name', headerName: 'FULL NAME', flex: 1 },
    { field: 'custom:buildingLicNo', headerName: 'LICENSE NUMBER', flex: 1 },
    { field: 'custom:buildingLicExp', headerName: 'EXPIRY', flex: 1 },
    { field: 'priorityListing', headerName: 'PRIORITY STATUS', flex: 1 },
    { field: 'approved', headerName: 'ACTIVE STATUS', flex: 1 },
    {
      field: 'view',
      headerName: 'SEE BUILDER DETAILS',
      flex: 1,
      renderCell: param => (
        <Button
          variant="contained"
          style={styles.viewBtn}
          fullWidth
          onClick={() => {
            // console.log('SET BUILDER', param.row);
            setBuilder(param.row);
          }}
        >
          SEE BUILDER DETAILS
        </Button>
      ),
    },
  ];
  const style = {
    heading: {
      textAlign: 'center',
      fontSize: '2rem',
      paddingTop: '2rem',
    },
    searchBox: {
      marginBottom: '2rem',
    },
    tableContainer: {
      backgroundColor: COLORS.WHITE,
      margin: '2rem',
      padding: '1rem',
    },
    inputDiv: {
      marginRight: 'auto',
      marginLeft: 'auto',
      marginBottom: '20px',
      paddingBottom: '20px',
      borderRadius: '5px',
      backgroundColor: COLORS.GREY,
    },
    inputForm: {
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingTop: '1rem',
      paddingBottom: '1rem',
    },
    button: {
      fontSize: '1.1rem',
      color: COLORS.WHITE,
      backgroundColor: COLORS.GREEN,
    },
    buttonRej: {
      width: '90%',
      fontSize: '1.1rem',
      color: COLORS.WHITE,
      backgroundColor: COLORS.GREY_DARKER,
    },
    buttonApprove: {
      width: '90%',
      fontSize: '1.1rem',
      color: COLORS.WHITE,
      backgroundColor: COLORS.GREEN,
    },
    buttonInv: {
      fontSize: '1.1rem',
      marginTop: '1rem',
      color: COLORS.GREEN,
      backgroundColor: COLORS.WHITE,
    },
    loading: {
      textAlign: 'center',
      marginRight: 'auto',
      marginLeft: 'auto',
    },
    loadingWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 200,
    },
    filterContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 60px',
    },
    filterBody: {
      display: 'flex',
      alignItems: 'center',
    },
    filterHeading: {
      marginRight: '15px',
    },
  };
  const useStyles = makeStyles(theme => ({
    root: {
      border: 0,
      color:
        theme.palette.type === 'light'
          ? 'rgba(0,0,0,.85)'
          : 'rgba(255,255,255,0.85)',
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      WebkitFontSmoothing: 'auto',
      letterSpacing: 'normal',
      '& .MuiDataGrid-columnsContainer': {
        backgroundColor: COLORS.GREY,
      },
      '& .MuiDataGrid-iconSeparator': {
        display: 'none',
      },
      '& .MuiDataGrid-colCell, .MuiDataGrid-cell': {
        borderRight: `0px'
        }`,
      },
      '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
        borderBottom: `2px solid ${
          theme.palette.type === 'light' ? '#f0f0f0' : '#303030'
        }`,
      },
      '& .MuiDataGrid-cell': {
        color:
          theme.palette.type === 'light'
            ? 'rgba(0,0,0,.85)'
            : 'rgba(255,255,255,0.65)',
      },
      '& .MuiPaginationItem-root': {
        borderRadius: 0,
      },
    },
  }));
  const classes = useStyles();

  const filteredBuilders = builders.filter((builder, index) => {
    builder.id = index;
    if (activityStatus === 'All') {
      return builder;
    }
    return builder.approved === activityStatus;
  });
  return (
    <div>
      <div style={style.filterContainer}>
        <h3>Results: {filteredBuilders.length} </h3>
        <div style={style.filterBody}>
          <h3 style={style.filterHeading}>Filter By :</h3>
          <Select
            value={activityStatus}
            labelId="activity-status"
            onChange={e => setActivityStatus(e.target.value)}
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Not Active">Not Active</MenuItem>
            <MenuItem value="Deactivated">Deactivated</MenuItem>
          </Select>
        </div>
      </div>
      {/* {builders.map((builder, index) => {
        builder.id = index;
        buildersUpdated.push(builder);
        return '';
      })} */}
      <div style={style.tableContainer}>
        <DataGrid
          className={classes.root}
          rows={filteredBuilders}
          columns={columns}
          pageSize={10}
          disableColumnMenu
          disableColumnSelector
          density="comfortable"
          disableSelectionOnClick
          autoHeight
        />
      </div>

      {/* {builders &&
        builders.map(builder => (
          <BuilderCard
            builder={builder}
            setBuilder={setBuilder}
            key={builder.username}
          />
        ))} */}
    </div>
  );
};

const propTypes = {
  setBuilder: PropTypes.func,
  builders: PropTypes.array,
};

const cardPropTypes = {
  // setBuilder: PropTypes.func,
  builder: PropTypes.object,
};

BuilderCard.propTypes = cardPropTypes;
BuilderResults.propTypes = propTypes;

export default BuilderResults;
